import { Directive, HostListener, EventEmitter, Output, Input } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[profDragDropFile]'
})
export class DragDropFileDirective {

  @Input() public acceptedExtensions: Array<string>;
  @Output() public filesChangeEmiter: EventEmitter<File[]> = new EventEmitter();
  @Output() public filesInvalidEmiter: EventEmitter<File[]> = new EventEmitter();

  constructor() { }

  @HostListener('dragover', ['$event']) public onDragOver(evt) {
    this.preventDefaultAndStopPropagation(evt);
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    this.preventDefaultAndStopPropagation(evt);
  }

  @HostListener('drop', ['$event']) public onDrop(evt) {
    this.preventDefaultAndStopPropagation(evt);

    const files = evt.dataTransfer.files as File[];

    if (files && files.length > 0) {
      let validFiles = [];
      let invalidFiles = [];

      if(this.acceptedExtensions && this.acceptedExtensions.length > 0) {
        validFiles = Object.values(files).filter(file => this.hasValidExtension(file));
        invalidFiles = Object.values(files).filter(file => !this.hasValidExtension(file));
      }
      else{
        validFiles = files;
        invalidFiles = [];
      }
      
    
      if (validFiles.length > 0) {
        this.filesChangeEmiter.emit(validFiles);
      }
    
      if (invalidFiles.length > 0) {
        this.filesInvalidEmiter.emit(invalidFiles);
      }
    }
  }

  private preventDefaultAndStopPropagation(event): void {
    event.preventDefault();
    event.stopPropagation();
  }

  private hasValidExtension(file: File): boolean {
    const fileExtension = "." + file.name.split('.').pop()?.toLowerCase();
    return this.acceptedExtensions.includes(fileExtension);
  }

}
